const SENSITIVE_OAUTH_PARAMS = ["code", "error", "scope"] as const;

// Removes the live authorization code (plus scope/error) from a callback URL's
// query string so it no longer sits in the address bar / browser history after
// the callback has parsed it. This is defense-in-depth: the Referrer-Policy
// header (helm/ui/nginx/nginx.conf) is the primary fix that keeps these values
// out of the Referer header in the first place.
//
// `state` is deliberately kept. AuthWrapper's embed-OAuth detection
// (isIntegrationAuthRedirectInProgress in authWrapper.tsx) reads `state` live
// from window.location on every render to decide whether the embed popup
// should keep skipping the Auth0 wait; stripping it would flip that check
// false mid-flow and re-trigger the hang it exists to avoid. `state` is not a
// live credential, so keeping it here is not a Referer/log leak: it is still
// stripped from the Referer by the nginx header above, and redacted in log
// bodies by the collector.
//
// Not an absolute guarantee that the address bar is scrubbed: the URL fragment
// is intentionally left untouched (fragments are never sent in the Referer
// header, so they are not a leak vector), and `state` is now intentionally
// kept too. Callers apply this via window.history.replaceState AFTER the
// callback has parsed code/state/scope (see OAuthCallback); React Router holds
// location in memory, so rewriting window.location does not blank the parse.
export function stripSensitiveOAuthParamsFromUrl(href: string): string {
  const url = new URL(href);
  for (const param of SENSITIVE_OAUTH_PARAMS) {
    url.searchParams.delete(param);
  }
  return url.toString();
}
